/* eslint eqeqeq: "off" */

// 0/1 for a yes/no program field. Form selects hand back "0"/"1" strings, the
// server hands back numbers, older code used booleans; anything else is 0.
export const toFlag = (v) => (v === true || v == 1 ? 1 : 0);

// A course has "no custom fee" when the field was left blank (empty string /
// null). Blank means "inherit the branch default fee"; an explicit 0 is a real
// $0 override.
export const isBlankFee = (c) => c.custom_fee === "" || c.custom_fee == null;

// Courses with no price at this branch: blank custom fee and no branch
// default (default_fee === null). This is the resolved course_fee == null
// check, but on the editor's live state, so a custom fee typed in this
// session counts. default_fee undefined means the default is still being
// looked up (older server); those rows are not reported.
export const unpricedCourses = (courses) =>
  (courses || []).filter((c) => isBlankFee(c) && c.default_fee === null);

// Warn on save only when the program is offered on the website: with the
// flag off the site lists it contact-only anyway, so a missing price changes
// nothing there.
export const webRegisterPriceWarnings = (webRegisterInd, courses) =>
  toFlag(webRegisterInd) ? unpricedCourses(courses) : [];
